import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import APIKeysPage from './APIKeysPage';

export default flowRight(withVerificationGuard, withAuthGuard())(APIKeysPage);
